module.exports = __webpack_public_path__ + "static/media/PresseMedias.d2834848.pdf";